import React, { useState, useEffect } from 'react';
import { IonIcon, IonInput, IonButton } from '@ionic/react';
import './index.css';
import { isDefined, isWebConfig } from '../../lib/utils';
import { withTranslation } from '../../lib/translate';
import Mobiscroll from '../../components/mobiscroll';
import { NormalText } from '../common';

import check from '../../assets/images/Deli_Check.svg';
import wrong from '../../assets/images/Deli_Wrong.svg';
import moment from 'moment';
import { getConfig } from '../../appConfig';

const { DatePicker } = Mobiscroll;

const ValidateInput = ({ __, label, valid: validField, type, value: propValue, name, validatedData, onIonChange, onButtonClicked, ...rest }) => {
  const [value, setValue] = useState(propValue || '');
  const [show, setShow] = useState(name && validatedData && validatedData[name]);

  useEffect(() => {
    if (name) {
      const valid = validField && validatedData[name];
      setShow(valid);
    }
  }, [name, validatedData]);

  useEffect(() => {
    setValue(propValue);
  }, [propValue]);

  const togglePass = () => {
    if (type === 'email') {
      const validEmail = isDefined(value) && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(value);
      setShow(validEmail);
    } else {
      const validValue = isDefined(value) && value !== '';
      setShow(validValue);
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value);
    togglePass();
    if (onIonChange) {
      onIonChange(e);
    }
  };

  const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
  const defaultDateValue = moment().subtract(getConfig().restrictions?.min_registration_age || 18, 'years');
  return (
    <div className="okx-validate-input-wrapper">
      <div className="okx-validate-input-holder inline-input inline-input--validate">
        {type === 'date' && (
          <div className="date-picker-wrapper inline-input inline-input--validate">
            <DatePicker
              theme='ios'
              cssClass={`${isWebConfig() ? 'web' : ''} date-picker`}
              display="center"
              setText="Done"
              max={yesterday}
              min={new Date().getFullYear() - (getConfig().restrictions?.max_registration_age || 85)}
              defaultValue={defaultDateValue}
              onSet={(e, a) => handleChange({ target: { value: a.element.value } })}
              {...rest}
              value={value}
            />
          </div>
        )}
        {type === 'text' && <IonInput {...rest} value={value} onIonInput={handleChange}></IonInput>}
        {type === 'email' && <IonInput readonly {...rest} value={value} onIonInput={handleChange}></IonInput>}
        {type === 'tel' && <IonInput {...rest} value={value} onIonInput={handleChange}></IonInput>}
        {type === 'email_verified' && (
          <>
            {show ? (
              <NormalText>{__('Email verified')}</NormalText>
            ) : (
              <NormalText className='bold underlined pointer primary-color' onClick={onButtonClicked}>
                {__('Resend address validation email')}
              </NormalText>
            )}
          </>
        )}
      </div>
      <IonButton className='input-validator-button' fill='clear' size="small" onTouchStart={togglePass} onTouchEnd={togglePass}>
        <IonIcon slot="icon-only" icon={show ? check : wrong} />
      </IonButton>
    </div>
  );
};

export default withTranslation(ValidateInput);
